var Handlebars = require("/Users/mudio/Desktop/baidu/bce-multimedia/cyberplayer/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"jw-adv jw-reset\">\n    <div class=\"adv-countdown\"></div>\n    <div class=\"adv-close\">X</div>\n</div>";
},"useData":true});


/*****************
 ** WEBPACK FOOTER
 ** ./~/handlebars-loader!./src/templates/adv.html
 ** module id = 201
 ** module chunks = 0
 **/